import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mission" }
const _hoisted_2 = { class: "mission__top" }
const _hoisted_3 = { class: "mission__slider" }
const _hoisted_4 = { class: "quiz__question" }
const _hoisted_5 = { class: "quiz__question-wrap" }
const _hoisted_6 = { class: "mission__bottom" }

import DecorTitle from "@/components/uikit/DecorTitle.vue";
import UserPoints from "@/components/uikit/UserPoints.vue";
import GreenButton from "@/components/uikit/GreenButton.vue";
import { useGameStore } from "@/stores/index";
import { onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper/modules";
import { useRouter } from "vue-router";
import "swiper/css";


export default /*@__PURE__*/_defineComponent({
  __name: 'MissionScreen',
  setup(__props) {

const modules = [Navigation];
const store = useGameStore();
const router = useRouter();
const navigation = {
  nextEl: ".mission .slider-navigation__btn--next",
  prevEl: ".mission .slider-navigation__btn--prev",
};

// Выбор миссии
const selectMission = async () => {
  const swiperElement = document.querySelector(
    ".mission .swiper"
  ) as HTMLElement & { swiper?: any };
  if (!swiperElement?.swiper) return;

  const activeIndex = swiperElement.swiper.activeIndex;
  const activeMission = store.missionsList[activeIndex];

  if (activeMission) {
    await store.selectMission(activeMission.id);
    router.push("/role");
  }
};

onMounted(() => {
  store.getMissions();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mission__bg" }, [
      _createElementVNode("img", {
        src: "/images/mission-bg.jpg",
        alt: ""
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DecorTitle, {
        title: 'Выбери миссию своей команды',
        icon: '/images/mission-icon-top.svg'
      }),
      _createVNode(UserPoints, {
        count1: _unref(store).playerScore
      }, null, 8, ["count1"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Swiper), {
        centeredSlides: true,
        slidesPerView: 1.8,
        spaceBetween: 24,
        modules: modules,
        navigation: navigation
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).missionsList, (item) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "quiz__question-title" }, " МИФИСТ ОДНАЖДЫ МИФИСТ НАВСЕГДА ", -1)),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.text), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "quiz__question-decor" }, [
                    _createElementVNode("img", {
                      src: "/images/quiz-questions-decor.svg",
                      alt: ""
                    })
                  ], -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "quiz__question-decor quiz__question-decor--logo" }, [
                    _createElementVNode("img", {
                      src: "/images/quiz-questions-decor-2.svg",
                      alt: ""
                    })
                  ], -1))
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "slider-navigation" }, [
        _createElementVNode("div", { class: "slider-navigation__btn slider-navigation__btn--prev" }),
        _createElementVNode("div", { class: "slider-navigation__btn slider-navigation__btn--next" })
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(GreenButton, { onClick: selectMission }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("Далее")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})